import axios from "axios";

const per_page = 12
const getNews = async (context) => {
    await context.commit('setNews', null)
    const response = (await axios.get(`${process.env.VUE_APP_API_URL}/api/support/v1/news/list/?per_page=${per_page}`)).data
    if (response.success) {
        await context.commit('setNews', response)
    } else {
        await context.commit('setError', response.code)
    }
};
const paginationNews = async (context, page) => {
    await context.commit('setNews', null)
    const response = (await axios.get(`${process.env.VUE_APP_API_URL}/api/support/v1/news/list/?per_page=${per_page}&page=${page}`)).data
    if (response.success) {
        await context.commit('setNews', response)
    } else {
        await context.commit('setError', response.code)
    }
};
const getNewsBySlug = async (context, obj) => {
    await context.commit('setNews', null)
    const response = (await axios.get(`${process.env.VUE_APP_API_URL}/api/support/v1/news/detail/${obj}/`)).data
    if (response.success) {
        await context.commit('setNews', response.result)
    } else {
        await context.commit('setError', response.code)
    }
};

export default {
    getNews,
    getNewsBySlug,
    paginationNews,
}